import { Envelope } from '@phosphor-icons/react';
import { BOOKING_DISABLED, FALLBACK_EMAIL } from '../../config/maintenance';

/**
 * Az oldal tetején futó figyelmeztető sáv: amíg a Rackhost levél-fogadás vissza nem áll,
 * a foglalási és utalvány-rendelési form-ok le vannak tiltva, és a vendégeket a Gmail
 * címre irányítjuk át. Egyszerű, statikus, akadálymentes — `role="alert"`.
 */
export const MaintenanceBanner = () => {
  if (!BOOKING_DISABLED) return null;

  return (
    <div
      role="alert"
      className="fixed top-0 left-0 right-0 z-[60] bg-forest text-sand px-4 py-2.5 shadow-md border-b border-gold/30"
    >
      <div className="max-w-7xl mx-auto flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-center">
        <Envelope size={16} className="text-gold shrink-0" weight="duotone" />
        <p className="text-[12px] md:text-[13px] font-light leading-snug">
          <span className="font-semibold tracking-wide">Az online foglalási rendszer ideiglenesen szünetel.</span>{' '}
          <span className="opacity-90">
            Érdeklődést és foglalást kérjük közvetlenül az
          </span>{' '}
          <a
            href={`mailto:${FALLBACK_EMAIL}`}
            className="text-gold font-medium underline underline-offset-2 hover:text-sand transition-colors"
          >
            {FALLBACK_EMAIL}
          </a>{' '}
          <span className="opacity-90">címen küldjenek.</span>
        </p>
      </div>
    </div>
  );
};
